import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import PrivacyPolicy from "../pages/privacy/page";
import SecurityTrustCentre from "../pages/security/page";
import Subprocessors from "../pages/subprocessors/page";
import Terms from "../pages/terms/page";
import TryPage from "../pages/try/page";
import ForPage from "../pages/for/page";
import Support from "../pages/support/page";
import ZoomGuide from "../pages/zoom/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/privacy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/terms",
    element: <Terms />,
  },
  {
    path: "/security",
    element: <SecurityTrustCentre />,
  },
  {
    path: "/subprocessors",
    element: <Subprocessors />,
  },
  {
    path: "/try",
    element: <TryPage />,
  },
  {
    path: "/for",
    element: <ForPage />,
  },
  {
    path: "/support",
    element: <Support />,
  },
  {
    path: "/zoom",
    element: <ZoomGuide />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
